// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 40,
  argument: "The miseries of the life of man are relieved by the grace of God and his fear.",
  verses: [
    { n: 1, text: "Great labour is created for all men, and a heavy yoke is upon the children of Adam, from the day of their coming out of their mother's womb, until the day of their burial into the mother of all." },
    { n: 2, text: "Their thoughts and fears of the heart, their imagination of things to come, and the day of their end:" },
    { n: 3, text: "From him that sitteth on a glorious throne, unto him that is humbled in earth and ashes:" },
    { n: 4, text: "From him that weareth purple, and beareth the crown, even to him that is covered with rough linen: wrath, envy, trouble, unquietness, and the fear of death, continual anger and strife," },
    { n: 5, text: "And in the time of rest upon his bed, the sleep of the night changeth his knowledge." },
    { n: 6, text: "A little and as nothing is his rest, and afterward in sleep, as in the day of keeping watch." },
    { n: 7, text: "He is troubled in the vision of his heart, as if he had escaped in the day of battle. In the time of his safety he rose up, and wondereth that there is no fear:" },
    { n: 8, text: "Such things happen to all flesh, from man even to beast, and upon sinners are sevenfold more." },
    { n: 9, text: "Moreover, death and bloodshed, strife and sword, oppressions, famine, and affliction, and scourges:" },
    { n: 10, text: "All these things are created for the wicked, and for their sakes came the flood." },
    { n: 11, text: "All things that are of the earth shall return to the earth again, and all waters shall return to the sea." },
    { n: 12, text: "All bribery and injustice shall be blotted out, and fidelity shall stand for ever." },
    { n: 13, text: "The riches of the unjust shall be dried up like a river, and shall pass away a noise like a great thunder in rain." },
    { n: 14, text: "While he openeth his hands, he shall rejoice: but transgressors shall pine away in the end." },
    { n: 15, text: "The offspring of the ungodly shall not bring forth many branches, and make a noise as unclean roots upon the top of a rock." },
    { n: 16, text: "The weed growing over every water, and at the bank of the river, shall be pulled up before all grass." },
    { n: 17, text: "Grace is like a paradise in blessings, and mercy remaineth for ever." },
    { n: 18, text: "The life of a labourer, that is content with what he hath, shall be sweet, and in it thou shalt find a treasure." },
    { n: 19, text: "Children, and the building of a city, shall establish a name; but a blameless wife shall be counted above them both." },
    { n: 20, text: "Wine and music rejoice the heart: but the love of wisdom is above them both." },
    { n: 21, text: "The flute and the psaltery make a sweet melody, but a pleasant tongue is above them both." },
    { n: 22, text: "Thy eye desireth favour and beauty, but more than these green sown fields." },
    { n: 23, text: "A friend and companion meeting together, in season; but above them both, is a wife with her husband." },
    { n: 24, text: "Brethren are a help in the time of trouble, but mercy shall deliver more than they." },
    { n: 25, text: "Gold and silver make the feet stand sure, but wise counsel is above them both." },
    { n: 26, text: "Riches and strength lift up the heart, but above these is the fear of the Lord." },
    { n: 27, text: "There is no want in the fear of the Lord, and it needeth not to seek for help." },
    { n: 28, text: "The fear of the Lord is like a paradise of blessing, and they have covered it above all glory." },
    { n: 29, text: "My son, in thy life-time be not indigent; for it is better to die than to want." },
    { n: 30, text: "The life of him that looketh toward another man's table, is not to be counted a life: for he feedeth his soul with another man's meat." },
    { n: 31, text: "But a man well instructed and taught, will look to himself." },
    { n: 32, text: "Begging will be sweet in the mouth of the unwise, but in his belly there shall burn a fire." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Labour, \"anxiety,\" ascholia. (Menochius) — All misery (Calmet) is in consequence of original sin. (Worthington) — The life of man is a trial, Job vii. 1., and xiv. 1. — Of all. The earth, (Calmet) which covers us, when all other things cast us away.", attribution: "Pliny, [Natural History?] ii. 63." }
    ] },
    { verse: 4, notes: [
      { text: "Purple. Literally, \"hyacinth,\" (Haydock) or violet colour. Purple was more like scarlet.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Knowledge. He is disquieted by restless (Calmet) and frightful dreams,", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Fear, or no reason for it.", attribution: "Calmet" }
    ] },
    { verse: 8, notes: [
      { text: "Beast. Their instinct causes them to fear death, to fight, &c.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Moreover. Greek, \"death,\" &c., are all destined for the wicked.", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "Out, and severely punished. (Calmet) — They shall not appear in the book of life.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Rejoice. The corrupt judge once rejoiced: but now he shall mourn. (Haydock) — The possessions and grandeur of the unjust shall end in a moment, like a clap of thunder, Psalm xxxvi. 36., and Proverbs x. 25.", attribution: "Calmet" }
    ] },
    { verse: 15, notes: [
      { text: "And make. Greek, \"they are unclean,\" (Haydock) and will produce no fruit.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Weed. Literally, \"verdure.\" Greek Achei, (Haydock) properly denotes the rush, papyrus, which grows on the banks of the Nile, (Genesis xli. 2.; Calmet) and was used for fuel. (Alpin. i. 7.) (Matthew vi. 30.) — Thus the wicked will presently (Calmet) be treated.", attribution: "Menochius" }
    ] },
    { verse: 17, notes: [
      { text: "Grace. The beneficent will produce fruits, like those of paradise, Genesis ii. 8.", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "That is. Greek, \"and of one that.\" — In it. Greek, \"and more than both is one discovering a treasure,\" (Haydock) who finds himself rich, without labour or injustice.", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: "Both. Thus Judith, Zenobia, &c., ennobled their husbands, Proverbs xxxi. 10.", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "Wisdom. Virtue gives more content to the soul than corporal pleasures do to the body. It brings us near to God.", attribution: "Calmet" }
    ] },
    { verse: 22, notes: [
      { text: "Green. \"The sight of no colour is more agreeable to the eyes.\" (Pliny xxxvii. 1.) — The Church is more excellent than the synagogue.", attribution: "Worthington" }
    ] },
    { verse: 23, notes: [
      { text: "Husband. Their union is closer, and they can best assist each other.", attribution: "Haydock" }
    ] },
    { verse: 25, notes: [
      { text: "Counsel. By this the Romans conquered the world, 1 Machabees viii. 31., and Proverbs xi. 14.", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "Heart, and make people presumptuous; while piety gives real courage, Psalm xxvi. 1.", attribution: "Calmet" }
    ] },
    { verse: 28, notes: [
      { text: "It, or \"him.\" (Haydock) — The virtuous man is covered with glory.", attribution: "Haydock" }
    ] },
    { verse: 29, notes: [
      { text: "Indigent. Greek, \"live not by begging,\" being too lazy to work, or incurring this punishment for thy sins, Leviticus xxvi. 16., Psalm cviii., and Deuteronomy xv. 4. Involuntary poverty is a most severe scourge. (Calmet) — All are bound to labour for what is needful; (Worthington) some by prayer, others by trade, &c.", attribution: "Haydock" }
    ] },
    { verse: 30, notes: [
      { text: "Meat. Such is the condition of the parasite, (Calmet) and of the beggar.", attribution: "Haydock" }
    ] },
    { verse: 32, notes: [
      { text: "Unwise. Some read, \"impudent man,\" with the Greek. — Fire. He shall feel the inconveniences of poverty; (Haydock) yet will not work, being lost to all shame. (Calmet) — Plato (Leg. 11.) orders magistrates to \"clear the country of such an animal,\" zoou, (Haydock) and the Lacedemonians suffered no beggars among them.", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
